import React, { useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { TRUONGTHUCTAP_API } from '../../../../utils/apiUrl';
import { Post, Put } from '../../../../utils/httpProvider';
import { Formik } from 'formik';
import * as Yup from 'yup';

const TruongThucTapModal = ({ isOpen, handleClose, data, refetch }) => {
    const isEdit = !!data;
    const addMutation = useMutation((payload) => Post(TRUONGTHUCTAP_API.CREATE_ITEM, null, payload));
    const updateMutation = useMutation((payload) => Put(TRUONGTHUCTAP_API.UPDATE_ITEM, data?.id, payload));

    const initialValues = {
        maTruong: data?.maTruong || '',
        tenTruong: data?.tenTruong || '',
        diaChi: data?.diaChi || '',
        nguoiLienHe: data?.nguoiLienHe || '',
        dienThoai: data?.dienThoai || '',
        email: data?.email || '',
        ghiChu: data?.ghiChu || ''
    };

    const validationSchema = Yup.object().shape({
        maTruong: Yup.string().required('Mã cơ sở là bắt buộc'),
        tenTruong: Yup.string().required('Tên cơ sở là bắt buộc'),
        email: Yup.string().email('Email không đúng định dạng').nullable()
    });

    const handleSubmit = (values) => {
        const mutation = isEdit ? updateMutation : addMutation;
        mutation.mutate(values, {
            onSuccess: (res) => {
                if (res.id || res.status === 200 || res === true) {
                    toast.success(isEdit ? "Cập nhật cơ sở đào tạo thành công!" : "Thêm cơ sở đào tạo thành công!");
                    refetch();
                    handleClose();
                } else {
                    toast.error("Có lỗi xảy ra, vui lòng thử lại.");
                }
            },
            onError: (err) => {
                toast.error(err?.message || "Có lỗi xảy ra.");
            }
        });
    };

    return (
        <Modal show={isOpen} onHide={handleClose} size="lg" backdrop="static" style={{ zIndex: '9999' }}>
            <Modal.Header closeButton className="bg-primary text-white">
                <Modal.Title>{isEdit ? 'Chỉnh sửa cơ sở đào tạo' : 'Thêm cơ sở đào tạo mới'}</Modal.Title>
            </Modal.Header>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {({ values, errors, touched, handleChange, handleSubmit }) => (
                    <Form onSubmit={handleSubmit}>
                        <Modal.Body>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Mã cơ sở <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            name="maTruong"
                                            value={values.maTruong}
                                            onChange={handleChange}
                                            isInvalid={touched.maTruong && !!errors.maTruong}
                                            disabled={isEdit}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.maTruong}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Tên cơ sở đào tạo <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            name="tenTruong"
                                            value={values.tenTruong}
                                            onChange={handleChange}
                                            isInvalid={touched.tenTruong && !!errors.tenTruong}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.tenTruong}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col md={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Địa chỉ</Form.Label>
                                        <Form.Control
                                            name="diaChi"
                                            value={values.diaChi}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Người liên hệ</Form.Label>
                                        <Form.Control
                                            name="nguoiLienHe"
                                            value={values.nguoiLienHe}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Số điện thoại</Form.Label>
                                        <Form.Control
                                            name="dienThoai"
                                            value={values.dienThoai}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Email</Form.Label>
                                        <Form.Control
                                            name="email"
                                            type="email"
                                            value={values.email}
                                            onChange={handleChange}
                                            isInvalid={touched.email && !!errors.email}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col md={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Ghi chú</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            name="ghiChu"
                                            value={values.ghiChu}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>Đóng</Button>
                            <Button variant="primary" type="submit" disabled={addMutation.isLoading || updateMutation.isLoading}>
                                {(addMutation.isLoading || updateMutation.isLoading) ? 'Đang lưu...' : 'Lưu lại'}
                            </Button>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
};

export default TruongThucTapModal;
